import {
  EducatorsCustomClassesLiveClass,
  EducatorsCustomClassesLiveClassClassMembershipRequestsTrait,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  live_classes: Array<
    EducatorsCustomClassesLiveClass &
      EducatorsCustomClassesLiveClassClassMembershipRequestsTrait
  >
  class_name: string
}

export const useIndexProps = () => useProps<IndexProps>()
